import { useViewport } from '@gitbook/util-react-hooks';

import { GlassBrowser } from './GlassBrowser';
import { SiteTemplate } from './SiteTemplate';

export const PREVIEW_HEIGHT = 579;
export const PREVIEW_WIDTH = 1079;
export const PREVIEW_PADDING = 40;
export const MARGIN = 128;

const height = PREVIEW_HEIGHT + PREVIEW_PADDING * 2;
const width = PREVIEW_WIDTH + PREVIEW_PADDING * 2;

/**
 * Asset used in e.g. pagesplit aside assets. Contains:
 * - a glass browser 'chrome'
 * - a wireframed site template
 */
export function WireframedSiteAsset(props: { siteName?: string }) {
    const { siteName } = props;
    const viewport = useViewport();

    return (
        <div
            className="absolute flex"
            style={{
                height,
                width,
                // Center vertically with at least top and left margin
                top: Math.max(MARGIN, (viewport.height - height) / 2),
                left: Math.max(MARGIN, (viewport.width / 2 - width) / 2),
            }}
        >
            <GlassBrowser />
            <SiteTemplate name={siteName} height={PREVIEW_HEIGHT} />
        </div>
    );
}
